/**
 * Offset paging shared by the audit-trail feeds (workflow and task type
 * Activity): the next page starts after every entry already loaded, and the
 * pages flatten into one newest-first list.
 */

interface ActivityPage<Entry> {
  entries: Entry[];
  total: number;
  hasMore: boolean;
}

export const ACTIVITY_PAGE_SIZE = 50;

export function nextActivityOffset<Entry>(
  lastPage: ActivityPage<Entry>,
  pages: ActivityPage<Entry>[],
): number | undefined {
  return lastPage.hasMore
    ? pages.reduce((sum, page) => sum + page.entries.length, 0)
    : undefined;
}

export function flattenActivityPages<Entry>(
  data: { pages: ActivityPage<Entry>[] } | undefined,
): { entries: Entry[]; total: number } {
  return {
    entries: data?.pages.flatMap((page) => page.entries) ?? [],
    total: data?.pages[0]?.total ?? 0,
  };
}
